module.exports = __webpack_public_path__ + "img/btn-messege.de991e21.svg";